/**
 * Question status matching backend
 */
export enum QuestionStatus {
  PENDING = 'pending',
  TRIAGED = 'triaged',
  ASSIGNED = 'assigned',
  ANSWERED = 'answered',
  REJECTED = 'rejected',
  SENT = 'sent',
}

/**
 * Question source types
 */
export type QuestionSource = 'extension' | 'kai' | 'web' | 'whatsapp';

/**
 * Question document from API
 */
export interface Question {
  _id: string;
  question_text: string;
  title: string;
  answer_text?: string;
  status: QuestionStatus;
  priority: string;
  source?: QuestionSource;
  tenant_id: string;
  timestamp: string;
  created_at: string;
  updated_at: string;
  asker_name?: string;
  asker_id?: string;
  community?: string;
  category?: string;
  tags?: string[];
  group_name?: string;
  assigned_group?: {
    group_id: string;
    group_name: string;
    assigned_by: string;
    assigned_at: string;
  };
  assigned_doctor?: {
    doctor_id: string;
    doctor_name: string;
    doctor_email: string;
    assigned_at: string;
  };
  answered_by?: {
    doctor_id: string;
    doctor_name: string;
    doctor_email: string;
    answered_at: string;
  };
  sent_by?: string;
  sent_at?: string;
  delivery_channel?: string;
  is_favorite?: boolean;
  favorited_at?: string;
  rejection_note?: string;
  rejection_count?: number;
}

/**
 * Paginated response wrapper
 */
export interface PaginatedResponse<T> {
  items: T[];
  total: number;
  page: number;
  pageSize: number;
  hasNext: boolean;
  hasPrev: boolean;
}

/**
 * Question list filters
 */
export interface QuestionFilters {
  status?: QuestionStatus[];
  source?: QuestionSource[];
  dateFrom?: string;
  dateTo?: string;
  search?: string;
  category?: string;
  tags?: string[];
  answeredBy?: string;
  groupName?: string;
  assignedDoctor?: string;
  priority?: string;
  isFavorite?: boolean;
}

/**
 * Question statistics
 */
export interface QuestionStats {
  total: number;
  byStatus: Record<string, number>;
  bySource: Record<string, number>;
  byCategory: Record<string, number>;
  answeredCount: number;
  pendingCount: number;
  byDoctor: { doctorId: string; doctorName: string; answered: number; assigned: number }[];
  timeline: { date: string; count: number }[];
  avgResponseTime?: number;
}

/**
 * Filter options from API
 */
export interface FilterOptions {
  categories: string[];
  tags: string[];
  sources: string[];
  groups: string[];
  doctors: { id: string; name: string; email: string }[];
  priorities: string[];
}
